// FLAGSHIP — "Why Naive RAG Fails in Production (And How Grounded Hybrid
// Retrieval Actually Works)". ~16 min @ 30fps. Cold Compute / Neon kit.
//
// A problem-first PRODUCTION POSTMORTEM: each layer scene shows the failure it
// kills, then the mechanism that kills it. Every number/path is grounded in the
// EAKC-MVP repo (see metadata.md GROUNDING NOTE for the file/migration map).
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @ 30fps; contiguous.
// Durations are re-timed to FIT each scene's captions (last caption end + a
// readable tail) — no dead air. With sticky captions the last line persists to
// scene end, so the slide changes shortly after the final caption appears.
export const SCENE = {
  // 01 — confident, cited, completely wrong → blocked in <150ms, no LLM.
  hook: { start: 0, duration: 990 }, //             0:00–0:33
  // 02 — the naive-RAG strawman: embed → vector-search → prompt, and why it breaks.
  strawman: { start: 990, duration: 1260 }, //      0:33–1:15
  // 03 — Layer 1: AST structural chunking (tree-sitter, parent/reference metadata).
  astChunking: { start: 2250, duration: 1320 }, //  1:15–1:59
  // 04 — Layer 2: multi-signal RRF re-ranking (pgvector + BM25 + signals, fused).
  rrf: { start: 3570, duration: 1320 }, //          1:59–2:43
  // 05 — Layer 3: query-complexity router (strategy tiers, not one fat pipeline).
  router: { start: 4890, duration: 1110 }, //       2:43–3:20
  // 06 — Layer 4: semantic cache (cosine threshold; repeat skips the LLM; fail-closed).
  cache: { start: 6000, duration: 1110 }, //        3:20–3:57
  // 07 — Layer 5: source-maturity altitude guard (advisory stops narrating plans as live).
  maturity: { start: 7110, duration: 1140 }, //     3:57–4:35
  // 08 — Layer 6: the deterministic OUTPUT GATE (banned-vocab + ungrounded path/SHA + numeric).
  outputGate: { start: 8250, duration: 1560 }, //   4:35–5:27
  // 09 — Proof over time: the recency-correctness eval probe gating fresh-over-stale.
  recency: { start: 9810, duration: 1170 }, //      5:27–6:06
  // 10 — the full multi-layer pipeline draws on edge-by-edge.
  pipeline: { start: 10980, duration: 780 }, //     6:06–6:32
  // 11 — CLOSE: "Most channels show the happy path. This is the scar tissue."
  close: { start: 11760, duration: 780 }, //        6:32–6:58
} as const;

// 12540 frames = 418s = 6:58 @ 30fps (re-timed from 16:00 to remove dead air).
export const TOTAL_DURATION =
  SCENE.hook.duration +
  SCENE.strawman.duration +
  SCENE.astChunking.duration +
  SCENE.rrf.duration +
  SCENE.router.duration +
  SCENE.cache.duration +
  SCENE.maturity.duration +
  SCENE.outputGate.duration +
  SCENE.recency.duration +
  SCENE.pipeline.duration +
  SCENE.close.duration; // = 12540 (6:58 @ 30fps)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
